export default {"src":"/_next/static/media/waterskiën.935b357a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};